import api from '@pray/shared/utils/api';

export const getSocialClips = async ({ artistId = null, contentId = null } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/social-clips`;
  const response = await api.executeGetRequest(url);

  return response.data;
};
